import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginRegister.css";
import instance from "../../instance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Register() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [roleId, setRoleId] = useState("2");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("role");

    if (!token) {
      toast.error("You must be logged in to register a new user.");
      return;
    }

    if (userRole !== "admin") {
      toast.error(
        "You do not have the required permissions to register a new user."
      );
      return;
    }

    try {
      await instance.post(
        `users/register`,
        { username, password, roleId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("User registered successfully");
      navigate("/");
    } catch (error) {
      console.error("Registration failed:", error);
      if (error.response && error.response.status === 409) {
        toast.error("Username already exists");
      } else {
        toast.error("Registration failed");
      }
    }
  };

  return (
    <div>
      <header>
        <h2>Register</h2>
      </header>
      <button onClick={() => navigate("/")} className="button">
        ← Main
      </button>
      <div className="container">
        <div className="login-register-box">
          <main>
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <label htmlFor="username">Username:</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <label htmlFor="password">Password:</label>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="show show-password-toggle"
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>

              <div className="input-group">
                <label htmlFor="roleId">Role:</label> {/* حقل تحديد Role */}
                <select
                  id="roleId"
                  value={roleId}
                  onChange={(e) => setRoleId(e.target.value)}
                  required
                >
                  <option value="1">Admin</option>
                  <option value="2">User</option>
                  <option value="4">Supervisor</option>
                </select>
              </div>

              <button className="button4" type="submit">
                Register
              </button>
            </form>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Register;
